import * as types from './company-tools-category.types';
import * as constants from './company-tools-category.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeCompanyToolsCategory = generateStoreResourceAction<types.ICompanyToolsCategory>(
  constants.STORE_COMPANY_TOOLS_CATEGORY,
);
export const clearCompanyToolsCategory = generateClearResourceAction(constants.CLEAR_COMPANY_TOOLS_CATEGORY);
